/*
 * Sanjog: wishlist hearts on product cards.
 * Shares the theme's browser-saved wishlist (localStorage 'shopify_wishlist') with the
 * product-page heart, the header count and /pages/wishlist.
 */
(function () {
  var KEY = 'shopify_wishlist';

  function getList() {
    try {
      var parsed = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }
  function saveList(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function sync() {
    var list = getList();
    var saved = {};
    list.forEach(function (item) {
      if (item && item.handle) saved[item.handle] = true;
    });
    document.querySelectorAll('.card-wishlist-btn, .add-to-wishlist-btn').forEach(function (btn) {
      var on = !!saved[btn.getAttribute('data-handle')];
      btn.classList.toggle('is-active', on);
      if (btn.classList.contains('card-wishlist-btn')) {
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      }
    });
    document.querySelectorAll('.header-wishlist-count, #header-wishlist-count').forEach(function (el) {
      if (list.length > 0) {
        el.textContent = list.length;
        el.style.display = 'flex';
      } else {
        el.style.display = 'none';
      }
    });
  }

  // Capture phase so the tap never reaches the card's product link.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      // The theme's product-page heart and the wishlist page's remove button update the list
      // themselves (and 'storage' events don't fire in the same tab); refresh hearts + count after.
      if (target.closest('.add-to-wishlist-btn, .remove-wishlist-btn')) {
        setTimeout(sync, 50);
        return;
      }

      var btn = target.closest('.card-wishlist-btn');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();

      var handle = btn.getAttribute('data-handle');
      var list = getList();
      var exists = list.some(function (item) {
        return item && item.handle === handle;
      });
      if (exists) {
        list = list.filter(function (item) {
          return item && item.handle !== handle;
        });
      } else {
        list.push({
          handle: handle,
          title: btn.getAttribute('data-title'),
          url: btn.getAttribute('data-url'),
          image: btn.getAttribute('data-image'),
          price: btn.getAttribute('data-price'),
          compare_at_price: btn.getAttribute('data-compare') || '',
          discount: btn.getAttribute('data-discount') || ''
        });
      }
      saveList(list);
      sync();
      btn.classList.add('card-wishlist-btn--pop');
      setTimeout(function () {
        btn.classList.remove('card-wishlist-btn--pop');
      }, 250);
    },
    true
  );

  // New cards arrive via infinite scroll, filters and recommendations: keep their hearts in sync.
  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  }

  function start() {
    sync();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('.card-wishlist-btn') || n.querySelector('.card-wishlist-btn'))) {
            queueSync();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) sync();
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) sync();
  });
})();
